mutation UpdateRestreamDestination(
  $contentId: ID!
  $id: ID!
  $input: UpdateRestreamDestinationInput!
) {
  updateRestreamDestination(contentId: $contentId, id: $id, input: $input) {
    id
  }
}
